import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Ciudad } from '../../domain/model/maestro/entity/ciudad.model';
import { ConfiguracionInferirConvenio } from '../../domain/model/maestro/entity/configuracion-inferir-convenio.model';
import { ConfiguracionInferirPiso } from '../../domain/model/maestro/entity/configuracion-inferir-piso.model';
import { ConfiguracionInferirSLA } from '../../domain/model/maestro/entity/inferir-sla.model';
import { MotivosNoAdmision } from '../../domain/model/maestro/entity/motivos-no-admision.model';
import { Municipio } from '../../domain/model/maestro/entity/municipio.model';
import { Piso } from '../../domain/model/maestro/entity/piso.model';
import { PlanSalud } from '../../domain/model/maestro/entity/plan-salud.model';
import { Programa } from '../../domain/model/maestro/entity/programa.model';
import { TipoConvenio } from '../../domain/model/maestro/entity/tipo-convenio.model';
import { TipoIdentificacion } from '../../domain/model/maestro/entity/tipo-identificacion.model';
import { TipoPrestacion } from '../../domain/model/maestro/entity/tipo-prestacion.model';
import { TipoAtencion } from '../../domain/model/maestro/entity/tipos-atencion.model';
import { Zona } from '../../domain/model/maestro/entity/zona.model';
import { MaestrosGateway } from '../../domain/model/maestro/gateway/maestros-gateway';
import { Conducta } from '../../domain/model/no-hospitalario/solicitud/entity/conducta.model';
import { MaestrosEnum } from '../../shared/utils/enums/maestros.enum';


interface HttpOptions {
    headers?: HttpHeaders;
    params?: HttpParams;
}

@Injectable({
    providedIn: 'root'
})
export class MaestrosApiService extends MaestrosGateway {

    private url: string;
    private port: string;

    constructor(private http: HttpClient) {
        super();
        this.url = `${environment.apiBaseUrl}`;
        this.port = `${environment.portBaseUrl}`;
    }


    consultarTiposIdentificacion(): Observable<TipoIdentificacion[]> {
        const url = `${this.url}/api_ingreso/maestros/tiposIdentificacion`;
        return this.http.get<TipoIdentificacion[]>(url);
    }

    consultarConfiguracionConvenio(idTipoAtencion: number, planContrato: string, anexoAtencionDomiciliaria: boolean): Observable<ConfiguracionInferirConvenio> {
        const url = `${this.url}${this.port}/api_ingreso/maestros/convenio/${idTipoAtencion}/${planContrato}/${anexoAtencionDomiciliaria}`;
        return this.http.get<ConfiguracionInferirConvenio>(url);
    }

    consultarPlanesSalud(): Observable<PlanSalud[]> {
        const url = `${this.url}${this.port}/api_ingreso/maestros/planesSalud`;
        return this.http.get<PlanSalud[]>(url);
    }

    consultarCiudades(): Observable<Ciudad[]> {
        const url = `${this.url}${this.port}/api_ingreso/maestros/ciudad`;
        return this.http.get<Ciudad[]>(url);
    }

    consultarMunicipios(idCiudad: string): Observable<Municipio[]> {
        const url = `${this.url}${this.port}/api_ingreso/maestros/municipio/${idCiudad}`;
        return this.http.get<Municipio[]>(url);
    }

    consultarTipoAtencionPorCodigo(codigoTipo: number): Observable<TipoAtencion[]> {
        const url = `${this.url}${this.port}/api_ingreso/maestros/tipoAtencionPorCodigoTipo/${codigoTipo}`;
        return this.http.get<TipoAtencion[]>(url);
    }

    consultarTipoPrestacionPorServicio(tipoServicio: number): Observable<TipoPrestacion[]> {
        const url = `${this.url}${this.port}/api_ingreso/maestros/tipoPrestacionPorServicio/${tipoServicio}`;
        return this.http.get<TipoPrestacion[]>(url);
    }

    consultarPisoPorCiudadProgramaPrestacion(idCiudad: string, idPrograma: string, idTipoPrestacion: string): Observable<ConfiguracionInferirPiso> {
        const url = `${this.url}${this.port}/api_ingreso/maestros/piso/${idCiudad}/${idPrograma}/${idTipoPrestacion}`;
        return this.http.get<ConfiguracionInferirPiso>(url);
    }

    consultarZonasPorPiso(idPiso: string): Observable<Zona[]> {
        const url = `${this.url}${this.port}/api_ingreso/maestros/zonas/${idPiso}`;
        return this.http.get<Zona[]>(url);
    }

    consultarPisoPorId(idPiso: string): Observable<Piso> {
        const url = `${this.url}${this.port}/api_ingreso/maestros/pisos/${idPiso}`;
        return this.http.get<Piso>(url);
    }

    consultarConductaPorId(idConducta: string): Observable<Conducta> {
        const url = `${this.url}${this.port}/api_ingreso/maestros/conductaPorId/${idConducta}`;
        return this.http.get<Conducta>(url);
    }

    consultarSlaPorPlanSaludPrestacion(idPlanSalud: string, idTipoPrestacion: string): Observable<ConfiguracionInferirSLA[]> {
        const url = `${this.url}${this.port}/api_ingreso/maestros/slaPorPlanSaludPrestacion/${idPlanSalud}/${idTipoPrestacion}`;
        return this.http.get<ConfiguracionInferirSLA[]>(url);
    }

    consultarTipoConvenios(): Observable<TipoConvenio[]> {
        const url = `${this.url}${this.port}/api_ingreso/opc/consultar-convenios`;
        return this.http.get<TipoConvenio[]>(url);
    }

    consultarProgramas(): Observable<Programa[]> {
        const url = `${this.url}${this.port}/api_ingreso/maestros/${MaestrosEnum.programas}`;
        return this.http.get<Programa[]>(url, { withCredentials: true }).pipe();
    }

    consultarMotivoCancelacion(): Observable<MotivosNoAdmision[]> {
        const url = `${this.url}${this.port}/api_ingreso/maestros/motivosCancelacion`;
        return this.http.get<MotivosNoAdmision[]>(url);
    }

    consultarInferirCopago(plan: string, codigoTipoAtencion: number): Observable<number> {
        const url = `${this.url}${this.port}/api_ingreso/maestros/copago/${plan}/${codigoTipoAtencion}`;
        return this.http.get<number>(url);
    }

    get<T>(endpoint: string, params?: HttpParams): Observable<T> {
        const url = `${this.url}${this.port}${endpoint}`;
        return this.http.get<T>(url, this._createOptions({ params }));

    }

    consultarMotivosNoAdmision(idAtencion: number): Observable<MotivosNoAdmision[]> {
        const url = `${this.url}${this.port}/api_ingreso/maestros/motivosNoAdmision/${idAtencion}`;
        return this.http.get<MotivosNoAdmision[]>(url);
    }

    private _createOptions(options?: HttpOptions): HttpOptions {
        return {
            headers: options?.headers,
            params: options?.params,
        };
    }

    public getTipoAtencionPorCodigo(codigoTipo: number): Observable<TipoAtencion[]> {
        const url = `${this.url}${this.port}/api_ingreso/maestros/tipoAtencionPorCodigoTipo/${codigoTipo}`;
        return this.http.get<TipoAtencion[]>(url, { withCredentials: true }).pipe();
    }


}
